import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';
import { getCzechSuklRsAtcGroups } from '~/libs/infrastructure/api/availability';

import { FiltersValue } from '../components/Filters';
import { buildAvailabilityParams } from './availabilityQueryParams';

const FETCH_PER_PAGE = 100;

export async function fetchAllFilteredAvailabilityGroups(
	filters: FiltersValue
): Promise<CzechSuklRsAtcGroupResponse[]> {
	const groups: CzechSuklRsAtcGroupResponse[] = [];
	let page = 1;
	let totalPages = 1;

	while (page <= totalPages) {
		const response = await getCzechSuklRsAtcGroups(buildAvailabilityParams(filters, page, FETCH_PER_PAGE));
		groups.push(...response.items);
		totalPages = response.pagination.totalPages;
		page += 1;
	}

	return groups;
}
